import React from 'react';

import Icon from '../../../../Icon/Icon';

import * as styles from './ModalHeader.module.scss';

interface props {
    onClose: ()=> void,
    children: React.ReactNode,
    labelledBy: string
}

const ModalHeader = ({ labelledBy, onClose, children }: props): JSX.Element => {
    return (
        <div aria-labelledby={labelledBy} className={styles.ModalHeader}>
            <h4 className="subheading">{children}</h4>
            <button type="button" onClick={onClose} className={styles.ModalHeaderCloseButton} title="Close dialog">
                <Icon size={14}>
                    <Icon.Cross />
                </Icon>
            </button>
        </div>
    );
};

export default ModalHeader;
